import { render, staticRenderFns } from "./PenAndComp.vue?vue&type=template&id=6948c2b5&"
import script from "./PenAndComp.vue?vue&type=script&lang=js&"
export * from "./PenAndComp.vue?vue&type=script&lang=js&"
import style0 from "./PenAndComp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports